<template>
  <BaseSimuladorIndicadorModal
    ref="baseModal"
    :modal-id="modalId"
    title="Simulador"
    numerador-label="Numerador"
    denominador-label="Denominador"
    :valor-numerador="nManual"
    :valor-denominador="dManual"
    :base-numerador="baseNumerador"
    :base-denominador="baseDenominador"
    :procedimentos-numerador="PROCEDIMENTOS_NUMERADOR"
    :procedimentos-denominador="PROCEDIMENTOS_DENOMINADOR"
    :tipos="TIPOS_CLASSIFICACAO"
    :calculate-result-fn="calcularResultado"
    :calculate-class-fn="calcularClasse"
    :apply-preset-fn="aplicarPreset"
    :format-delta-fn="formatDelta"
    :result-text-fn="montarTextoResultado"
    hint="💡 Os botões preenchem valores de exemplo. Ajuste manualmente pelos controles acima."
    @update:numerador="setNumerador"
    @update:denominador="setDenominador"
  />
</template>

<script>
import BaseSimuladorIndicadorModal from '@/pages/IndicadoresAps/components/BaseSimuladorIndicadorModal.vue'

export default {
  name: 'SimuladorOdontoModal',
  components: {
    BaseSimuladorIndicadorModal,
  },
  props: {
    modalId: {
      type: String,
      default: 'simulador-odonto-modal',
    },
    dadosPercentualMunicipio: {
      type: Object,
      default: () => ({}),
    },
    dadosPercentualEquipe: {
      type: Object,
      default: () => ({}),
    },
    dadosPercentualMicroArea: {
      type: Object,
      default: () => ({}),
    },
    selectedEquipe: {
      type: [Object, String],
      default: '',
    },
    selectedMicroArea: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      nManual: 0,
      dManual: 1,
      baseNumerador: 0,
      baseDenominador: 1,
      TIPOS_CLASSIFICACAO: [
        { value: 'Ótimo', label: 'Ótimo', description: '> 8' },
        { value: 'Bom', label: 'Bom', description: '> 6 e <= 8' },
        {
          value: 'Suficiente',
          label: 'Suficiente',
          description: '> 3 e <= 6',
        },
        { value: 'Regular', label: 'Regular', description: '<= 3' },
      ],
      PROCEDIMENTOS_NUMERADOR: [
        {
          icon: null,
          codigo: '03.07.01.007-4',
          desc: 'Tratamento restaurador atraumático (TRA/ART)',
        },
      ],
      PROCEDIMENTOS_DENOMINADOR: [
        {
          icon: null,
          codigo: '03.07.01.003-1',
          desc: 'Restauração de dente permanente anterior com resina composta.',
        },
        {
          icon: null,
          codigo: '03.07.01.008-2',
          desc: 'Restauração de dente decíduo posterior com resina composta.',
        },
        {
          icon: null,
          codigo: '03.07.01.009-0',
          desc: 'Restauração de dente decíduo posterior com amálgama.',
        },
        {
          icon: null,
          codigo: '03.07.01.010-4',
          desc: 'Restauração de dente decíduo posterior com ionômero de vidro.',
        },
        {
          icon: null,
          codigo: '03.07.01.011-2',
          desc: 'Restauração de dente decíduo anterior com resina composta.',
        },
        {
          icon: null,
          codigo: '03.07.01.012-0',
          desc: 'Restauração de dente permanente posterior com resina composta.',
        },
        {
          icon: null,
          codigo: '03.07.01.013-9',
          desc: 'Restauração de dente permanente posterior com amálgama',
        },
        {
          icon: null,
          codigo: '03.07.01.007-4',
          desc: 'Tratamento restaurador atraumático (TRA/ART).',
        },
      ],
    }
  },
  methods: {
    open() {
      this.aplicarFonte()
      this.$refs.baseModal.open()
    },

    close() {
      this.$refs.baseModal.close()
    },

    aplicarFonte() {
      let fonte = this.dadosPercentualMunicipio

      if (this.selectedMicroArea) {
        fonte = this.dadosPercentualMicroArea
      } else if (this.selectedEquipe) {
        fonte = this.dadosPercentualEquipe
      }

      const numerador = Number(fonte?.numerador) || 0
      const denominador = Number(fonte?.denominador) || 1

      this.nManual = numerador
      this.dManual = denominador
      this.resetBase()
    },

    setNumerador(valor) {
      this.nManual = valor
    },

    setDenominador(valor) {
      this.dManual = valor
    },

    resetBase() {
      this.baseNumerador = this.nManual
      this.baseDenominador = this.dManual
    },

    calcularResultado({ numerador, denominador }) {
      const d = Number(denominador) || 0
      if (d <= 0) return 0

      const n = Number(numerador) || 0
      return Number(((n / d) * 100).toFixed(2))
    },

    calcularClasse({ resultado }) {
      if (resultado > 8) {
        return { nivel: 'Ótimo', variant: 'primary' }
      }
      if (resultado > 6 && resultado <= 8) {
        return { nivel: 'Bom', variant: 'success' }
      }
      if (resultado > 3 && resultado <= 6) {
        return { nivel: 'Suficiente', variant: 'warning' }
      }
      if (resultado <= 3) return { nivel: 'Regular', variant: 'danger' }

      return { nivel: 'Regular', variant: 'danger' }
    },

    aplicarPreset({ tipo, setNumerador, setDenominador }) {
      if (tipo === 'Ótimo') {
        setNumerador(9)
        setDenominador(100)
      } else if (tipo === 'Bom') {
        setNumerador(7)
        setDenominador(100)
      } else if (tipo === 'Suficiente') {
        setNumerador(4)
        setDenominador(100)
      } else {
        setNumerador(3)
        setDenominador(100)
      }

      this.$nextTick(() => {
        this.resetBase()
      })
    },

    formatDelta(val) {
      if (val > 0) return `+${val}`
      if (val < 0) return `${val}`
      return ''
    },

    montarTextoResultado({ resultado }) {
      return `NM / DN × 100`
    },
  },
}
</script>
